<div class="sorting-detail" (mouseleave)="closePopUp()">
<ul>
    <li  *ngFor="let li of data" (click)="sendValues(li.val)" [ngClass]="{active: isActive && sortType === li.val}"> {{li.name}}</li>
</ul>
</div>